export const isValidRange = (
  firstVisibleIndex: any,
  lastVisibleIndex: any,
  minValue: number,
  maxValue: number,
) => {
  return (
    typeof firstVisibleIndex === "number" &&
    typeof lastVisibleIndex === "number" &&
    !isNaN(firstVisibleIndex) &&
    !isNaN(lastVisibleIndex) &&
    firstVisibleIndex >= minValue &&
    lastVisibleIndex <= maxValue
  );
};

export const formatPercent = (percent: any) => {
  if (percent === null || percent === undefined || isNaN(percent) || percent < 0) {
    return "--";
  }
  const value = (100 * percent).toFixed(2);
  return `${parseFloat(value)}%`;
};
